import React from 'react';
import _ from 'lodash';
import { useNewResquestForm } from 'Hooks';
import { HubsLogbookService, PartMasterService } from 'Services';
import { ConvertNewRequestFormToHubsLogbookModel } from 'Components';
import { HubsLogbook } from 'Models';
import { ValidateFormFields } from 'Helpers';
import { CAEModal, ErrorModel, Form, FormComponent, FormField } from '@cae/component-library';
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";

export interface NewRequestModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    onAddNewRequest?: (HubsLogbook: HubsLogbook) => void;
    isAdmin: boolean;
}
export const NewRequestModal: React.FC<NewRequestModalProps> = ({ open, setOpen, onAddNewRequest, isAdmin }) => {
    const { t } = useTranslation("forms");
    const { enqueueSnackbar } = useSnackbar();
    const freshRequestForm = useNewResquestForm(t, isAdmin).newRequestForm;
    const [newRequestForm, setNewRequestForm] = React.useState<Form>(_.cloneDeep(freshRequestForm));
    const [formErrors, setFormErrors] = React.useState<ErrorModel[]>([]);

    React.useEffect(() => {
        setNewRequestForm(_.cloneDeep(freshRequestForm));
    }, [freshRequestForm]);

    const handleOnClickClose = React.useCallback(() => {
        setOpen(false);
        setNewRequestForm(_.cloneDeep(freshRequestForm));
    }, [setOpen, freshRequestForm]);

    const handleOnChangeForm = React.useCallback((handleOnChangeForm: string, formField: FormField) => {
        if (handleOnChangeForm === "partNumber") {
            PartMasterService.GetByPartNumber(formField.value)
                .subscribe({
                    next: partMaster => {
                        setNewRequestForm(() => {
                            const newForm = _.cloneDeep(newRequestForm);
                            //const newForm = { ...newRequestForm };
                            newForm.itemCost.value = String(partMaster.unitCost ?? '0.0'); // put return value from fetch here. (I have put the itemNumber as an example)
                            return newForm;
                        });
                    }
                });
        }
    }, [newRequestForm]);

    const handleOnFormSubmit = () => {
        const formErrors = ValidateFormFields(newRequestForm);
        setFormErrors(formErrors);
        if (formErrors.length === 0) {
            HubsLogbookService.InsertHubsLogbook(ConvertNewRequestFormToHubsLogbookModel(newRequestForm)).subscribe({
                next: insertedHubsLogbook => {
                    if (onAddNewRequest) {
                        onAddNewRequest(insertedHubsLogbook);
                    }
                    handleOnClickClose();
                },
                error: error => enqueueSnackbar(error.toString(), { variant: "error" })
            });
        }
    }

    return (
        <CAEModal
            actionButtonText="Add"
            actionButtonAction={handleOnFormSubmit}
            cancelButtonText="Cancel"
            cancelButtonAction={handleOnClickClose}
            open={open}
            setOpen={setOpen}
            title="New Request"
            contentType='node'
        >
            <FormComponent form={newRequestForm} errors={formErrors} onChange={handleOnChangeForm} />
        </CAEModal>
    );
}